export enum SAVE_FORM_RESULT {
  SAVED_ONLINE = 'SAVED_ONLINE',
  SAVED_OFFLINE = 'SAVED_OFFLINE',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  FINISH_FAILED = 'FINISH_FAILED' // saved but finish failed
}
